export default {
    data() {
        return {
            obligations: {
                additional_funding: 10000,
                max_contractual_penalty: 25000,
                obligation_cooperate: [],
                management_duty: [],
                loss_coverage: [],
                comprehensive_management_right: [],
                management_right: [],
                procuration_right: [],
                issue_instructions: [],
                special_draft_law: [],
                special_attendance_law: [],
                right_to_chair: [],
                right_use_special_profits: [],
                comprehensive_veto_right: [],
                veto_right: [],
                voting_right: [],
                dispatch_right: [],
                board_nomination_right: [],
                chairman: [],
                deputy_chairman: [],
                special_sales: [],
                transfer_permission: [],
                pick_up_sequences: [],
                advisory_board: [],
                advisory_board_nomination: [],
                advisory_board_chairman_right: [],
                deputy_advisory_board_chairman_right: [],
            },
            obligationTerms,
        };
    },
    computed: {
        pickedUpPartners() {
            return _.flatten(this.obligations.pick_up_sequences);
        },
        obligationTermsNotSelected() {
            return _.difference(this.obligationTerms, this.selectedTerms).length === this.obligationTerms.length;
        },
    },
    watch: {
        'obligations.loss_coverage.0':{
            deep: true,
            handler(item) {
                _.forEach(this.obligations.loss_coverage, (value, index) => {
                    if (index !== 0) {
                        this.obligations.loss_coverage[index].amount = item.amount;
                        this.obligations.loss_coverage[index].amount_type = item.amount_type;
                        this.obligations.loss_coverage[index].date = item.date;
                        this.obligations.loss_coverage[index].duty_to_contribute = item.duty_to_contribute;
                    }
                });
            }
        }
    },
    created() {
        if (!this.obligations.obligation_cooperate.length) {
            this.fillObligationFields();
        }
    },
    methods: {
        fillObligationFields() {
            this.addCooperateObligation();
            this.addManagementDuty();
            this.addLossCoverageFields( {}, false);
            this.addComprehensiveManagementRight();
            this.addManagementRight();
            this.addProcurationRight();
            this.addIssueInstructions();
            this.addSpecialDraftLaw();
            this.addSpecialAttendanceLaw();
            this.addRightToChair();
            this.addRightUseSpecialProfits();
            this.addComprehensiveVetoRight();
            this.addVetoRight();
            this.addVotingRight();
            this.addDispatchRight();
            this.addBoardNominationRight();
            this.addChairman();
            this.addDeputyChairman();
            this.addSpecialSales(false);
            this.addTransferPermission();
            this.addPickUpLevel(false);
            this.addAdvisoryBoard();
            this.addAdvisoryBoardNomination();
            this.addAdvisoryBoardChairmanRight();
            this.addDeputyAdvisoryBoardChairmanRight();
        },
        addCooperateObligation() {
            this.addDutyFields('obligation_cooperate', {}, false);
        },
        addManagementDuty() {
            this.addDutyFields('management_duty', {}, false);
        },
        addComprehensiveManagementRight() {
            this.addSpecialRightFields('comprehensive_management_right', {
                right_activation: 'months',
                right_activation_months: 36
            }, false);
        },
        addManagementRight() {
            this.addSpecialRightFields('management_right', {
                right_activation: 'months',
                right_activation_months: 36
            }, false);
        },
        addProcurationRight() {
            this.addSpecialRightFields('procuration_right', {
                right_activation: 'months',
                right_activation_months: 36
            }, false);
        },
        addIssueInstructions() {
            this.addSpecialRightFields('issue_instructions', {}, false);
        },
        addSpecialDraftLaw() {
            this.addSpecialRightFields('special_draft_law', {}, false);
        },
        addSpecialAttendanceLaw() {
            this.addSpecialRightFields('special_attendance_law', {}, false);
        },
        addRightToChair() {
            this.addSpecialRightFields('right_to_chair', {special_directorship_law: true},  false);
        },
        addRightUseSpecialProfits() {
            this.addSpecialRightFields('right_use_special_profits', {}, false);
        },
        addComprehensiveVetoRight() {
            this.addSpecialRightFields('comprehensive_veto_right', {}, false);
        },
        addVetoRight() {
            this.addSpecialRightFields('veto_right', {vote_percent: 60}, false);
        },
        addVotingRight() {
            this.addSpecialRightFields('voting_right', {vote_percent: 10}, false);
        },
        addDispatchRight() {
            this.addSpecialRightFields('dispatch_right', {}, false);
        },
        addBoardNominationRight() {
            this.addSpecialRightFields('board_nomination_right', {person_count: 3}, false);
        },
        addChairman() {
            this.addSpecialRightFields('chairman', {}, false);
        },
        addDeputyChairman() {
            this.addSpecialRightFields('deputy_chairman', {}, false);
        },
        addTransferPermission() {
            this.addSpecialRightFields('transfer_permission', {}, false);
        },
        addAdvisoryBoard() {
            this.addSpecialRightFields('advisory_board', {}, false);
        },
        addAdvisoryBoardNomination() {
            this.addSpecialRightFields('advisory_board_nomination', {person_count: 3}, false);
        },
        addAdvisoryBoardChairmanRight() {
            this.addSpecialRightFields('advisory_board_chairman_right', {}, false);
        },
        addDeputyAdvisoryBoardChairmanRight() {
            this.addSpecialRightFields('deputy_advisory_board_chairman_right', {}, false);
        },
        addSpecialSales(preselect = true) {
            const notSelectedPartners = this.getNotSelectedPartners('special_sales');
            const partner = preselect ? (notSelectedPartners.length ? notSelectedPartners[0].id : null) : null;

            const specialRightFields = {
                partner: partner,
                age_duration: 'age',
                share_percent: partner ? notSelectedPartners[0].share_percent - 1 : 0,
                age: 75,
                transferability: true,
            };

            this.obligations.special_sales.push(specialRightFields);
        },
        addPickUpLevel(preselect = true) {
            const pickUpLevels = Object.keys(this.obligations.pick_up_sequences);
            const nextLevel = pickUpLevels.length ? pickUpLevels.length : 0;

            this.obligations.pick_up_sequences.push([]);
            if (preselect) {
                this.addPickUpPartner(nextLevel);
            }
        },
        removePickUpLevel() {
            this.obligations.pick_up_sequences.pop();
        },
        addPickUpPartner(levelId) {
            const notSelectedPartners = _.difference(this.partnerIds, this.pickedUpPartners);

            this.obligations.pick_up_sequences[levelId].push(notSelectedPartners[0]);
        },
        removePickUpPartner(sequence) {
            sequence.pop();
        },
        addLossCoverageFields(fields = {}, preselect = true) {
            const notSelectedPartners = this.getNotSelectedPartners('loss_coverage');
            const partner = preselect ? (notSelectedPartners.length ? notSelectedPartners[0].id : null) : null;

            const dutyFields = Object.assign({
                partner: partner,
                amount: 10000,
                date: this.dates.balance_sheet_date + ((new Date).getFullYear() + 3),
                duty_to_contribute: 'till_date',
                amount_type: 'selected_amount',
                transferability: true,
            }, fields);

            this.obligations['loss_coverage'].push(dutyFields);
        },
        addDutyFields(item, fields = {}, preselect = true) {
            const notSelectedPartners = this.getNotSelectedPartners(item);
            const partner = preselect ? (notSelectedPartners.length ? notSelectedPartners[0].id : null) : null;

            const dutyFields = Object.assign({
                partner: partner,
                weekly_hours: 20,
                date: this.dates.balance_sheet_date + ((new Date).getFullYear() + 3),
                duty_to_contribute: 'till_date',
                transferability: true,
            }, fields);

            this.obligations[item].push(dutyFields);
        },
        addSpecialRightFields(item, fields = {}, preselect) {
            const notSelectedPartners = this.getNotSelectedPartners(item);
            const partner = preselect ? (notSelectedPartners.length ? notSelectedPartners[0].id : null) : null;

            const specialRightFields = Object.assign({
                partner: partner,
                age_duration: 'age',
                age: 75,
                transferability: true,
            }, fields);

            this.obligations[item].push(specialRightFields);
        },
        getNotSelectedPartners(obligation) {
            const selectedPartners = this.obligations[obligation].length ? this.obligations[obligation].map((item) => item.partner) : [];
            const notSelectedPartners = _.filter(this.partners, (partner) => !selectedPartners.includes(partner.id));

            return _.orderBy(notSelectedPartners, 'share_percent', 'desc');
        },
        canAddObligationRow(obligation) {
            const partnersCount = this.partnerIds.length;
            let hasNullPartner = false;
            obligation.forEach(item => {
                if (!item.partner) {
                    hasNullPartner = true;
                }
            });

            return (partnersCount > 1) && (obligation.length < partnersCount) && !hasNullPartner;
        },
        removeObligationRow(obligations) {
            if (obligations.length > 1) {
                obligations.pop();
            } else {
                obligations[0].partner = null;
            }
        },
        removeFromObligationList(partnerId) {
            const defaultPartnerId = this.partnerIds[0];

            _.forEach(this.obligations, (obligation, obligationName) => {
                if (Array.isArray(obligation)) {
                    if (obligationName !== 'pick_up_sequences') {
                        if (obligation.length > 1) {
                            this.obligations[obligationName] = obligation.filter((item) => item.partner !== partnerId);
                        } else {
                            obligation[0].partner = defaultPartnerId;
                        }
                    } else {
                        this.obligations.pick_up_sequences.forEach((sequence, levelId) => {
                            if (sequence.includes(partnerId)) {
                                if (sequence.length === 1) {
                                    this.obligations.pick_up_sequences.splice(levelId, 1);
                                } else {
                                    const index = sequence.indexOf(partnerId);
                                    if (index > -1) {
                                        sequence.splice(index, 1);
                                    }
                                }
                            }
                        });
                    }
                }
            });
        }
    },
};
